import { Box, Text, PinInput } from "@chakra-ui/react";

const VerificationStep = ({ code, onCodeChange, onResend }) => {
  return (
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <PinInput.Root
            size={{ base: "lg", md: "2xl" }}
            mb={6}
            autoFocus
            value={code}
            onValueChange={(e) => onCodeChange(e.value)}
        >
          <PinInput.HiddenInput />
          <PinInput.Control
              display="flex"
              justifyContent="center"
              flexWrap="wrap"
              gap={{ base: 2, md: 4 }}
          >
            {[0, 1, 2, 3].map((i) => (
                <PinInput.Input key={i} index={i} size={{ base: "lg", md: "2xl" }} />
            ))}
          </PinInput.Control>
        </PinInput.Root>
        <Text onClick={onResend} textDecoration="underline" cursor="pointer" mb={10}>
          Resend Code
        </Text>
      </Box>
  );
};

export default VerificationStep;